import { __ } from "@wordpress/i18n";
import { DocOutline } from "./doc-outline";
import { PromptArea } from "./prompt";
import { DocProvider } from "./context";
import { PluginRequired } from "@/components/plugin-required";

export default function App() {
    return (
        <PluginRequired plugin="eazydocs">
            <DocProvider>
                <Docs />
            </DocProvider>
        </PluginRequired>
    );
}

function Docs() {
    return (
        <div className="atml-docs">
            <PromptArea />
            <DocOutline />
        </div>
    );
}
